import styled from 'styled-components';

export const PhotoListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
